import { RoutePaths } from '@global/routePaths';
import { NavigationGuard } from '@core/guards/navigation.guard';

export const ConfirmationRoutes = [
  {
    path: RoutePaths.NEW_QUOTATION.CONFIRMATION.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/confirmation/confirmation.module').then(m => m.ConfirmationPageModule),
    canActivate: [NavigationGuard],
  },
];
